module.exports = __webpack_public_path__ + "static/media/antigua-historic-19.c21ba502.jpg";